import * as Mod1 from "./discourse/initializers/narrative-bot-admin-plugin-configuration-nav";
const compatModules = {
  "discourse/initializers/narrative-bot-admin-plugin-configuration-nav": Mod1,
};
export { compatModules };
export default compatModules;
